var render, staticRenderFns
import script from "./productLevel.vue?vue&type=script&lang=js"
export * from "./productLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbcff786')) {
      api.createRecord('bbcff786', component.options)
    } else {
      api.reload('bbcff786', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/terminal_info/form/components/productLevel/productLevel.vue"
export default component.exports